(() => {
  'use strict';
  const key = 'tm_contact_submission_v2';
  const ttl = 30 * 60 * 1000;
  let fired = false;
  let timer;
  let attempts = 0;
  const form = () => document.getElementById('contact_form');
  const pending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      return value && value.id && Date.now() - value.time < ttl ? value : null;
    } catch { return null; }
  };
  const track = () => {
    const current = form();
    if (fired || !current || !current.querySelector('input[name="form_type"][value="contact"]') || !current.querySelector('.banner--success, .tm-contact__notice--success')) return;
    const submission = pending();
    if (!submission || submission.path !== location.pathname) return;
    if (typeof window.gtag !== 'function') {
      if (!timer && attempts++ < 150) timer = setTimeout(() => { timer = null; track(); }, 100);
      return;
    }
    fired = true;
    window.gtag('event', 'conversion', {
      send_to: 'AW-16886154836/CbDACKb6ts0cENSM-fM-',
      transaction_id: submission.id
    });
    try { sessionStorage.removeItem(key); } catch {}
  };
  document.addEventListener('submit', event => {
    if (event.target !== form() || !event.target.checkValidity()) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        id: crypto.randomUUID(), time: Date.now(), path: location.pathname
      }));
    } catch {}
  }, true);
  const initialize = () => {
    track();
    const observer = new MutationObserver(() => {
      track();
      if (fired) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();

/* Tailor Mail GA4: confirmed leads and telephone-link clicks; no customer field values. */
(() => {
  'use strict';
  if (window.tmGa4LeadsInitialized) return;
  window.tmGa4LeadsInitialized = true;
  const destination = 'G-DPE0NP2SDH';
  const key = 'tm_ga4_lead_pending_v1';
  const ttl = 30 * 60 * 1000;
  let sent = false;
  let timer = null;
  let attempts = 0;
  let lastPhoneClick = 0;
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch { return false; }
  };
  const formFor = id => ['contact_form', 'HoaInquiryForm'].includes(id) ? document.getElementById(id) : null;
  const read = () => {
    try {
      const p = JSON.parse(sessionStorage.getItem(key) || 'null');
      return p && p.id && p.path === location.pathname && Date.now() - p.time >= 0 && Date.now() - p.time < ttl ? p : null;
    } catch { return null; }
  };
  const send = (name, params) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, Object.assign({send_to: destination}, params));
    return true;
  };
  const track = () => {
    if (sent) return;
    const p = read();
    const form = p && formFor(p.form);
    if (!form || !form.querySelector('input[name="form_type"][value="contact"]') ||
        !form.querySelector('.banner--success, .tm-contact__notice--success, .tm-hoa-form-alert--success')) return;
    if (send('generate_lead', {form_id:p.form, lead_type:p.form === 'HoaInquiryForm' ? 'hoa_inquiry' : (p.path === '/pages/installation-service' ? 'installation_quote' : 'contact_inquiry')})) {
      sent = true;
      try { sessionStorage.removeItem(key); } catch {}
    } else if (!timer && attempts++ < 150) {
      timer = setTimeout(() => {timer = null; track();}, 100);
    }
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || formFor(form.id) !== form || !form.checkValidity() || !allowed()) return;
    try { sessionStorage.setItem(key, JSON.stringify({id:crypto.randomUUID(),time:Date.now(),path:location.pathname,form:form.id})); } catch {}
  }, true);
  document.addEventListener('click', event => {
    const link = event.target?.closest?.('a[href^="tel:"]');
    if (!link || Date.now() - lastPhoneClick < 1500) return;
    if (send('phone_click', {contact_method:'phone',page_path:location.pathname})) lastPhoneClick = Date.now();
  }, true);
  document.addEventListener('visitorConsentCollected', track);
  const initialize = () => {
    track();
    const observer = new MutationObserver(() => { track(); if (sent) observer.disconnect(); });
    observer.observe(document.body, {childList:true,subtree:true});
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {if (!error) track();});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
